import React from 'react';
import styles from './Error.module.css';
import lang from '../../languages/en.json';

interface ErrorProps {
  message: string;
  hideGenericMessage?: boolean;
}

const ErrorPage: React.FC<ErrorProps> = ({ message, hideGenericMessage }) => {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorCard}>
        <h2 className={styles.errorTitle}>Error</h2>
        <p className={styles.errorMessage}>{message}</p>
        {!hideGenericMessage && <p>{lang.commonErrors.genericCareCenterMessage}</p>}
      </div>
    </div>
  );
};

export default ErrorPage;
